<template>
	<div id="market">
			<div class="maket_banner" v-cloak></div>
		<div class="hezuotop">
			<h1 class="hezuotitle">合作银行</h1>
			<p class="hezuotext">本公司研发的"农产品电子追溯+智慧支付系统"在浙江省各地区100多个农贸及农批市场投入使用,并凭借多模式、高效率、低成本之优势得到了用户的广泛认同</p>
			<div class="allyuanbox">
				<div :class="['yuanbox',sclick?'active':'']" @click="sclicks(0)">
					<div class="yuan">农商银行</div>
					<div class="xian"></div>
				</div>
				<div :class="['yuanbox',!sclick?'active':'']" @click="sclicks(1)">
					<div class="yuan ">更多银行</div>
					<div class="xian"></div>
				</div>

			</div>
		</div>
		<div class="swiper-container" id="bank_swiper">
			<div class="swiper-wrapper">
				<div class="swiper-slide">
					<div class="hezuobottom" v-show="sclick">
						<div class="l">
							<ul>
								<li class="ml78">东阳农商银行</li>
								<li class="ml28">永康农商银行</li>
								<li>成泰农商银行</li>
								<li class="ml28">武义农商银行</li>
								<li class="ml78">浦江农商银行</li>
							</ul>
						</div>
						<div :class="['c']">
							<img src="static/img/img_logo_nsyh.png" alt="" />
						</div>
						<div class="r">
							<li class="mr78">磐安农商银行</li>
							<li class="mr28">临海农商银行</li>
							<li>温岭农商银行</li>
							<li class="mr28">路桥农商银行</li>
							<li class="mr78">玉环农商银行</li>
						</div>
					</div>
				</div>
				<div class="swiper-slide">
					<div class="hezuobottom " v-show="sclick">
						<div class="l">
							<ul>
								<li class="ml78">定海农商银行</li>
								<li class="ml28">岱山农商银行</li>
								<li>吴兴农商银行</li>
								<li class="ml28">德清农商银行</li>
								<li class="ml78">安吉农商银行</li>
							</ul>
						</div>
						<div :class="['c',sclick?'active':'']">
							<img src="static/img/img_logo_nsyh.png" alt="" />
						</div>
						<div class="r">
							<li class="mr78">南浔农商银行</li>
							<li class="mr28">长兴农商银行</li>
							<li style="visibility: hidden;">吴兴农商银行</li>
							<li style="visibility: hidden;" class="ml28">德清农商银行</li>
							<li style="visibility: hidden;" class="ml78">安吉农商银行</li>
						</div>
					</div>
				</div>
			</div>
			<div class="swiper-button-next"></div>
			<div class="swiper-button-prev"></div>
		</div>
		<div class="hezuobottom hezuobottom1" v-show="!sclick">
			<div class="l">
				<ul>
					<li class="ml78">工商银行龙湾支行</li>
					<li class="ml28">工商银行椒江支行</li>
					<li>工商银行武义支行</li>
					<li class="ml28">建设银行舟山分行</li>
					<li class="ml78">建设银行义乌支行</li>
				</ul>
			</div>
			<div class="c active">
				<img src="static/img/img_logo_qtyh.png" alt="" />
			</div>
			<div class="r">
				<li class="mr78">建设银行杭州分行</li>
				<li class="mr28">建设银行嘉兴分行</li>
				<li>建设银行桐乡支行</li>
				<li class="mr28">农业银行桐乡支行</li>
				<li class="mr78">邮政储蓄银行丽水分行</li>
			</div>
		</div>
		
	
		<div class="market_smart">
			<div class="market_smartTitle">
				智慧市场
				<div class="market_smartSub">融智慧计量、智慧追溯、智慧检测、智慧支付、智慧运营于一体的新型农贸（批）市场</div>
			</div>
			<div class="market_smartList clickStyle" v-for="(item,index) in smarts" @click.stop="navTo(index)">
				<a :href="item.href" style="height: 0;width: 0;display: block;overflow: hidden;">{{item.name}}</a>
				<img class="market_smartImg" v-lazy="item.imgPath">
				<div class="market_smartContent">
					<div class="market_smartName">市场名称：{{item.name}}</div>
					<div class="market_smartLocation">
						<div><img src="http://img.anxuan360.com/FkuId2Z6PRJvmqZ9TUMGbALJI_f4">所在地区：{{item.location}}</div>
						<div><img src="http://img.anxuan360.com/FjRdKZclQF2Jvy_5flGxBNABPgoD">合作银行：{{item.bank}}</div>
					</div>
					<div class="market_smartIntro">{{item.intro}}</div>
					<div class="market_smartTail">{{item.tail}}</div>
				</div>
			</div>
		</div>
		<div class="market_other">
			<div class="market_otherTitle">更多市场</div>
			<div class="market_otherList">
				<div class="market_otherList_left" @click="pageJump(-1)"></div>
				<div class="market_otherLists">
					<div v-for="(item,index) in others" class="market_otherMarket" v-show="index>=12*marketpage && index<12*(marketpage+1)">
						<div class="market_otherMarket_img"><img src="http://img.anxuan360.com/Ftdc8SHhetQ4MGx-iucwdV0zKqPZ" alt="" /></div>
						<div class="market_otherMarket_text">
							<div class="market_otherMarket_name">{{item.name}}</div>
							<div class="market_otherMarket_address">{{item.address}}</div>
						</div>
					</div>
				</div>
				<div class="market_otherList_right" @click="pageJump(1)"></div>
			</div>
		</div>
	</div>
</template>

<script>
import Swiper from 'swiper'
	import 'swiper/dist/css/swiper.min.css'
	export default {
		metaInfo() {
			return {
				meta: [{
						name: 'renderer',
						content: 'http://www.ax168.com/market'
					},
					{
						name: 'market',
						content: '智慧市场。客户案例'
					},
					{
						name: 'keywords',
						content: '智慧农贸,智慧市场，智慧菜场，电子追溯，电子支付，智慧农贸,数字农贸,智慧农贸市场,智慧城市,菜篮子,农贸市场管理,农贸市场管理系统,溯源单子秤,智慧菜场,智慧菜市场,智慧市场,农贸市场智慧化建设方案,智慧微菜场,农贸市场管理软件,智慧农贸电子秤,农贸市场管理软件,菜市场管理系统,菜市场管理软件,新型农贸市场,O2O菜场，重要产品追溯系统,智慧农贸信息化平台,食品追溯监管系统,企业产品追溯系统,农产品追溯系统,仓储配送系统,智慧支付系统'
					},
					{
						name: 'description',
						content: '浙江安宣信息技术有限公司，国家高新技术企业，咨询热线0571-87357305，智慧菜场、智慧农贸、智慧农批、智慧市场、食品安全信息化监管和食品安全追溯平台以及农贸O2O电商平台。'
					}
				]
			}
		},
		data() {
			return {
						xuanzhuan: false,
				sclick: true,
				myone: '0',
				mycompantets: '0',
				bankType: 0, //0农商银行，1其他银行
				smarts: [{
						name: '府苑新村农贸市场',
						location: '杭州西湖',
						bank: '建设银行杭州分行',
						intro: '府苑新村农贸市场每个摊位都配备着智能显示屏，上面显示摊主的信息食材价格检测结果等，力求让顾客买得放心，吃得安心。',
						tail: '府苑新村农贸市场开业：诗意杭州热闹市井',
						imgPath: 'http://img.anxuan360.com/FvfZHMMnvrdNlUO5Jz5sa5x313O9',
						url: 'http://www.sohu.com/a/331235427_120082162',
						href: 'http://www.ax168.com/marketC?activeIndex=0'
					},
					{
						name: '东阳西门市场',
						location: '金华东阳',
						bank: '东阳农商银行',
						intro: '以后到“智慧菜场”买菜再也不会被支付方式困扰了，一个二维码就可以解决。我局联合东阳农商银行推出了“丰收一码通”。消费者可以选择微信、支付宝以及丰收互联APP任意一种方式付款。“花式”付款，就是这么任性！',
						tail: '福利！凭二维码就能搞定一切……这样的“智慧菜场”在东阳亮相了',
						imgPath: 'http://img.anxuan360.com/Fpl1Jnejrc0MxHondxQa7s6UopmC',
						url: 'https://mp.weixin.qq.com/s/4eef7pfIgwdnNxN-nVXjVQ',
						href: 'http://www.ax168.com/marketC?activeIndex=1'
					},
					{
						name: '义乌词林菜场',
						location: '金华义乌',
						bank: '义乌建设银行',
						intro: '9月19日，全省农批市场食品安全规范化建设现场推进会在义乌召开。省食品安全委员会办公室专职副主任、省食品药品监督管理局副局长卢永福出席会议并讲话，省财政厅、省食品药品监督管理局相关处室负责人及全省各地市市场监督管理局相关负责人、食用农产品批发市场（简称“农批市场”）负责人共110人参加会议。',
						tail: '全省农批市场食品安全规范化建设现场推进会在义乌召开',
						imgPath: 'http://img.anxuan360.com/Fpn3oNGmj-2_vD7py0HIapCOTCs5',
						url: 'https://mp.weixin.qq.com/s/F8LPQGBf_bXKXK-5GlcGUg',
						href: 'http://www.ax168.com/marketC?activeIndex=2'
					},
					{
						name: '磐安安文蔬菜市场',
						location: '金华磐安',
						bank: '磐安农商银行',
						intro: '为了让新市场达到规范经营、放心购买、安全食用的目标，该县市场监管局与农商银行合作，推出两大实招：一是推进食品溯源系统建设。实现市场内经营户的电子秤与农商银行一码通产品相互连接，消费者通过扫码支付就能了解到食品的安全情况，实现蔬菜从田间到商户交易全程可追溯。二是开展商户电子交易激励活动。',
						tail: '扫码可溯源 山城磐安打造智慧蔬菜市场',
						imgPath: 'http://img.anxuan360.com/Fmlqbw7tffv8-Ck4bRthnbUCHmGi',
						url: 'https://zj.zjol.com.cn/news.html?id=1003064&from=groupmessage&isappinstalled=0',
						href: 'http://www.ax168.com/marketC?activeIndex=3'
					},
					{
						name: '温岭水果批发市场',
						location: '台州温岭',
						bank: '温岭农商银行',
						intro: '持温岭农商银行丰收信用卡在丰收智能付POS机上刷卡消费，享受单笔满减优惠，单笔满100元立减10元、满300元立减30元、满500元立减50元，单卡单日只限享受一次，按最高档计算，先到先得，送完即止。',
						tail: '温岭市果蔬批发市场迎“五一”特惠大酬宾活动',
						imgPath: 'http://img.anxuan360.com/FvK5VHtKl4MTvmLIPNDLMJrx7HgD',
						url: 'https://mp.weixin.qq.com/s/wyYsm_qoPAl7IHpmLAOFPA',
						href: 'http://www.ax168.com/marketC?activeIndex=4'
					},
					{
						name: '庆元香菇市场',
						location: '丽水庆元',
						bank: '庆元农商银行',
						intro: '2015年以来，丽水市市场监管局以“源头可溯、全程可控、风险可防、责任可究、公众可查”为目标，探索“政府－银行－市场”三方合作模式。 目前丽水市溯源系统运行稳定、上下游数据对接有效、经营户和消费者逐步接受、社会各界反响良好，溯源体系建设取得初步成效。',
						tail: '福利！凭二维码就能搞定一切……这样的“智慧菜场”在东阳亮相了',
						imgPath: 'http://img.anxuan360.com/FrCsDXwXn8Ml8vq8M8-vRJkFlhqN',
						url: 'https://mp.weixin.qq.com/s/Wtvncjb_HLMKgrjefh3_Ag',
						href: 'http://www.ax168.com/marketC?activeIndex=5'
					}
				],
				marketpage: 0,
				others: [{
						name: '温州瑞安',
						address: '温州瑞安市水产城'
					},
					{
						name: '温州苍南',
						address: '温州浙福边贸水产城'
					},
					{
						name: '温州苍南',
						address: '苍南县灵溪城中农贸市场'
					},
					{
						name: '温州瓯海',
						address: '娄桥农贸市场'
					},
					{
						name: '温州瓯海',
						address: '瞿溪农贸市场'
					},
					{
						name: '温州瓯海',
						address: '梧田农贸市场'
					},
					{
						name: '温州龙湾',
						address: '温州市龙湾区沙中村海鲜菜市场'
					},
					{
						name: '温州泰顺',
						address: '泰顺县司前农贸市场'
					},
					{
						name: '湖州吴兴',
						address: '湖州金龙家苑农贸市场'
					},
					{
						name: '湖州吴兴',
						address: '湖州市红丰农贸市场'
					},
					{
						name: '湖州德清',
						address: '德清县乾元长桥农贸市场'
					},
					{
						name: '湖州德清',
						address: '德清县新市仙潭市场'
					},
					{
						name: '湖州安吉',
						address: '安吉县递铺中心农贸市场'
					},
					{
						name: '湖州安吉',
						address: '安吉县梅溪综合市场'
					},
					{
						name: '湖州南浔',
						address: '南浔新区农贸市场'
					},
					{
						name: '湖州南浔',
						address: '湖州南浔浔东中心农贸市场'
					},
					{
						name: '湖州长兴',
						address: '长兴龙山农贸市场'
					},
					{
						name: '湖州长兴',
						address: '长兴中心农贸市场'
					},
					{
						name: '金华东阳',
						address: '西门菜市场'
					},
					{
						name: '金华东阳',
						address: '东门菜场'
					},
					{
						name: '金华永康',
						address: '永康市华丰菜场'
					},
					{
						name: '金华永康',
						address: '永康市丽州商城菜场'
					},
					{
						name: '金华武义',
						address: '武义县汪村综合市场'
					},
					{
						name: '金华武义',
						address: '武义县溪南蔬菜市场'
					},
					{
						name: '金华磐安',
						address: '磐安县玉山农贸市场'
					},
					{
						name: '金华磐安',
						address: '磐安县安文蔬菜市场'
					},
					{
						name: '金华磐安',
						address: '新渥菜市场'
					},
					{
						name: '金华磐安',
						address: '仁川菜市场'
					},
					{
						name: '金华磐安',
						address: '冷水菜市场'
					},
					{
						name: '金华磐安',
						address: '方前菜市场'
					},
					{
						name: '金华磐安',
						address: '尚湖菜市场'
					},
					{
						name: '金华义乌',
						address: '下市菜市场'
					},
					{
						name: '金华义乌',
						address: '银海菜市场'
					},
					{
						name: '金华义乌',
						address: '福田菜市场'
					},
					{
						name: '金华义乌',
						address: '桥东菜市场'
					},
					{
						name: '金华义乌',
						address: '伏龙山菜市场'
					},
					{
						name: '金华义乌',
						address: '湖山菜市场'
					},
					{
						name: '金华义乌',
						address: '词林菜市场'
					},
					{
						name: '台州临海',
						address: '临海第二中心菜场'
					},
					{
						name: '台州临海',
						address: '临海市洪池菜场'
					},
					{
						name: '台州临海',
						address: '临海市两水农贸市场'
					},
					{
						name: '台州临海',
						address: '临海市大洋综合市场'
					},
					{
						name: '台州临海',
						address: '临海市开发区中心菜场'
					},
					{
						name: '台州温岭',
						address: '温岭市水果批发市场'
					},
					{
						name: '台州椒江',
						address: '台州市椒江白云菜场'
					},
					{
						name: '台州椒江',
						address: '台州市椒江建设路菜场'
					},
					{
						name: '台州椒江',
						address: '台州市椒江花园菜市场'
					},
					{
						name: '台州路桥',
						address: '路桥中心菜市场'
					},
					{
						name: '台州路桥',
						address: '路桥蓬街综合市场'
					},
					{
						name: '舟山定海',
						address: '舟山市金叶蔬菜果品批发市场'
					},
					{
						name: '舟山定海',
						address: '舟山市新城丰茂农贸市场'
					},
					{
						name: '舟山岱山',
						address: '岱山县竹屿新区菜场'
					},
					{
						name: '丽水云和',
						address: '云和县城西菜市场'
					},
					{
						name: '丽水云和',
						address: '云和县农贸市场'
					},
					{
						name: '丽水青田',
						address: '青田县船寮综合市场'
					},
					{
						name: '丽水青田',
						address: '坭湾菜市场'
					},
					{
						name: '丽水青田',
						address: '油竹菜市场'
					},
					{
						name: '丽水景宁',
						address: '景宁县中心菜市场'
					},
					{
						name: '丽水缙云',
						address: '缙云新区农贸市场'
					},
					{
						name: '绍兴上虞',
						address: '绍兴市滨海新城沥海综合市场'
					},
					{
						name: '宁波宁海',
						address: '宁海县兴海农产品综合市场'
					},
					{
						name: '杭州桐庐',
						address: '桐庐商业广场'
					},
					{
						name: '丽水莲都',
						address: '仓前菜场'
					},
					{
						name: '丽水莲都',
						address: '府前菜场'
					},
					{
						name: '丽水莲都',
						address: '九里综合市场'
					},
					{
						name: '丽水莲都',
						address: '城西菜场'
					},
					{
						name: '丽水莲都',
						address: '丽水东港蔬菜批发交易市场'
					},
					{
						name: '丽水莲都',
						address: '莲都区灯塔菜场'
					},
					{
						name: '丽水莲都',
						address: '东银苑菜市场'
					},
					{
						name: '丽水莲都',
						address: '西银苑菜市场'
					},
					{
						name: '丽水莲都',
						address: '丽水莲都紫金菜市场'
					},
					{
						name: '丽水松阳',
						address: '松阳东菜场'
					},
					{
						name: '丽水松阳',
						address: '松阳田园农产品综合市场'
					},
					{
						name: '丽水云和',
						address: '云和县菜市场'
					},
					{
						name: '丽水云和',
						address: '云和县农贸市场'
					},
					{
						name: '丽水遂昌',
						address: '遂昌县府前中心市场'
					},
					{
						name: '丽水青田',
						address: '中心菜市场'
					},
					{
						name: '丽水青田',
						address: '城东菜市场'
					},
					{
						name: '丽水青田',
						address: '大埠头菜市场'
					},
					{
						name: '丽水青田',
						address: '油竹综合市场'
					},
					{
						name: '丽水青田',
						address: '江南菜市场'
					},
					{
						name: '丽水青田',
						address: '青田县戈岙湾蔬菜批发市场'
					},
					{
						name: '丽水庆元',
						address: '庆元县菇城农贸市场'
					}
				],
			}
		},
		activated() {
			document.documentElement.style.fontSize = "";
		},
		mounted: function() {
	
			this.dli = document.querySelectorAll(".hezuobottom li");
			this.dimg = document.querySelectorAll(".hezuobottom .c");
			window.addEventListener('scroll', this.menu)
			
      
		},
		methods: {
		sclicks(data) {
				if(data) {
					this.sclick = false
					
				} else {
					this.sclick = true
				}
			},
			destroyed() {
				window.removeEventListener('scroll', this.menu);
			},
			menu() {
				if(this.dimg[0].getBoundingClientRect().top - document.documentElement.clientHeight < -50) {
					this.dimg[0].classList.add("active");
					this.dimg[1].classList.add("active");
				}
				for(var i = 0; i < this.dli.length; i++) {
					if(this.dli[i].getBoundingClientRect().top - document.documentElement.clientHeight < -50) {
						this.dli[i].classList.add("active");
					}
				}
  this.$nextTick(() => {  
            var swiper = new Swiper('#bank_swiper', {
              paginationClickable: true,
              nextButton: '#bank_swiper .swiper-button-next',
              prevButton: '#bank_swiper .swiper-button-prev',
              parallax: true,
              speed: 500,
              loop: true,
            });

        })
			},
			// 选择银行类型
			chooseBankType: function(type) { //0农商银行，1其他银行
				this.bankType = type;
			},
			// 点击跳转页面
			gotoLink: function(url) {
				window.open(url);
			},
			//点击转到智慧市场的跳转页面
			gotoSmart: function(url) {
				window.open(url);
			},
			navTo: function(index) {
				this.$router.push({
					path: '/marketC',
					query: {
						activeIndex: index
					},
				})

				this.select = this.$route.path;
			},
			pageJump: function(page) {
				var min = 0;
				var max = parseInt(this.others.length / 12);
				this.marketpage = this.marketpage + page;
				//当前页数
				if(this.marketpage < min) {
					this.marketpage = max;
				} else if(this.marketpage > max) {
					this.marketpage = min;
				}
			}
		}
	}
</script>

<style >
	@import url("../css/market.css");
	@import url('../css/partners.css');
	[v-cloak] {
		display: none !important;
	}

</style>


// WEBPACK FOOTER //
// src/components/market.vue